import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './../http.service';

@Injectable({
  providedIn: 'root'
})
export class ArticleTypologyService {
  constructor(private httpService: HttpService) {}

  getTypologies(): Observable<{ articleTypologies: string[] }> {
    return this.httpService.httpGet('article/typologies');
  }
}
